import {CancelButton, ModalBase, Text} from '../1elements'
import ButtonLayoutDiv from '../4layout/ButtonLayoutDiv'
import SaveButton from '../1elements/Buttons/TextButtons/SaveButton'
import Box from '@mui/material/Box'

const GroupCreateModalBase = ({header, children, cancelHandler, saveHandler, open, setOpen}) => {
    return (
        <ModalBase open={open} setOpen={setOpen}>
            <Box sx={{ padding: '10px' }}>
                <Text type='selectOwnerModalHeader'>{header}</Text>
                <Box sx={{ margin: '20px 0 40px', padding: '0 20px', width: '100%', maxWidth: 'none' }}>
                    {children}
                </Box>
                <ButtonLayoutDiv>
                    <CancelButton onClick={cancelHandler} />
                    <SaveButton onClick={saveHandler} />
                </ButtonLayoutDiv>
            </Box>
        </ModalBase>
    )
}

export default GroupCreateModalBase
